import { Controller } from '@hotwired/stimulus';
import { closeAllModal } from '../../../design_system/components/modal';

export default class extends Controller {
  static targets = [
    'alert',
    'input',
    'dateInput',
    'actionChoice',
    'actionChoiceWrapper',
    'dossierSelect',
    'otherDossierSelect',
    'dossierSelectWrapper',
    'otherDossierSelectWrapper',
    'submitButton',
  ];

  connect() {
    if (this.dateInputTarget.value === '') {
      this.alertTarget?.classList.add('d-none');
    }

    this.actionChoiceTargets.forEach((el) => {
      el.addEventListener('change', () => {
        this.switchSelectInput();
        this.submitForm();
      });
    });

    this.dossierSelectTarget.addEventListener('change', () => {
      this.submitForm();
    });

    this.otherDossierSelectTarget.addEventListener('change', () => {
      this.submitForm();
    });

    this.dateInputTarget.addEventListener('change', () => {
      this.submitForm();
    });

    this.inputTargets.forEach((el) => {
      el.addEventListener('change', () => {
        this.submitForm();
      });
    });

    this.submitButtonTarget.addEventListener('click', () => {
      this.showLoader();
    });
  }

  switchSelectInput() {
    this.dossierSelectWrapperTarget.classList.toggle('d-none');
    this.otherDossierSelectWrapperTarget.classList.toggle('d-none');
  }

  // to close all modals before rendering the flash message (delegation créée)
  closeModal(event) {
    if (event.detail.fetchResponse.response.redirected) {
      closeAllModal();
    }
  }

  submitForm() {
    if (this.incompleteForm()) return;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'management_delegation_assignment[validate_only]';
    input.value = true;

    this.element.appendChild(input);
    this.element.requestSubmit();

    input.remove();
  }

  incompleteForm() {
    return !this.dossierId() || !this.dateInputTarget.value;
  }

  dossierId() {
    const checkedOption = this.actionChoiceTargets.find(el => el.parentElement.classList.contains('checked'));

    if (checkedOption.value === 'true') {
      return this.dossierSelectTarget.value;
    } else {
      return this.otherDossierSelectTarget.value;
    }
  }

  showLoader() {
    const loader = this.submitButtonTarget.querySelector('.content-loader');

    loader.classList.add('content-loader--visible');
  }
}
